import axios from "axios";
import config from "config";
import md5 from "md5";
import type { ILocalAPIFormatedResponseModel } from "models/locker/forms/LocalAPIFormatedResponseModel";
import type { ILocalAPIResponseModel } from "models/locker/forms/LocalAPIResponseModel";
import { pad } from "utils/methods/pad";
import { formatJsonToKeyValue } from "utils/methods/formatJsonToKeyValue";

const BASE_URL = config.urllocker;

export default class LocalAPI {
  //BASE/locker/check/01/01/hash
  static async checkOpenDoor(id: string, serialPort: string): Promise<ILocalAPIFormatedResponseModel> {
    const result = await axios.get(LocalAPI.mountURL("check", id), {
      params: { serial_port: serialPort },
    });

    return {
      result: LocalAPI.isOpen(result.data),
      resultData: formatJsonToKeyValue(result.data)
    };
  }

  //BASE/locker/open/01/01/hash
  static async openDoorCommand(id: string, serialPort: string): Promise<ILocalAPIFormatedResponseModel> {
    const result = await axios.get(LocalAPI.mountURL("open", id), {
      params: { serial_port: serialPort },
    });

    return {
      result: LocalAPI.isOpen(result.data),
      resultData: formatJsonToKeyValue(result.data)
    };
  }

  //return true to open and false to close.
  static isOpen(data: ILocalAPIResponseModel[]): boolean {
    const { status } = Array.isArray(data) ? data[0] : data;
    return status.slice(-1) === "O"; //or C de Close
  }

  //create hash to get value.
  static get hash(): string {
    const key = "123456";
    const word = "LOCKERYS";
    return md5(`${key}${word}`).toLowerCase();
  }

  // mount url.
  static mountURL(action: string, id: string): string {
    return `${BASE_URL}/locker/${action}/01${id ? "/" + pad(id, 2) : ""}/${LocalAPI.hash}`;
  }
}
